/**
 * Auxilia na troca do tamanho da imagem vtex que estão presentes na URL da imagem.
 *
 * @param src string
 * @param width number
 * @param height number
 */
export const replaceVtexSrcImageSize = (src: string, width: number, height: number) => {
  const result = src.match('/ids/(?<imageId>.*)-(?<w>.*)-(?<h>.*)/')
  if (!result) {
    return src
  }

  const { imageId, w, h } = result?.groups ?? {}

  if (!imageId || !w || !h) {
    return src
  }

  return src.replace(`/ids/${imageId}-${w}-${h}/`, `/ids/${imageId}-${width}-${height}/`)
}
